// extracted by mini-css-extract-plugin
export default {"player-wrapper":"VideoBox_player-wrapper__jKGP0","react-player":"VideoBox_react-player__2YEWd"};